import Vue from 'vue'

Vue.prototype.$util = {
  // 解析链接上面的参数
  getRequest(url) {
    const params = {}
    url = (url || location.href).replace(/.*\?(.*)/, '$1')
    url.replace(/([^=&]*)=([^&]*)/g, (match, a, b) => {
      params[a] = b
    })
    return params
  },
  evil(fn) {
    const Fn = Function // 一个变量指向Function，防止有些前端编译工具报错
    return new Fn('return ' + fn)()
  },
  isBase64(str) {
    if (str === '' || str.trim() === '') return
    try {
      return btoa(atob(str)) === str
    } catch (err) {
      return false
    }
  },
  formatNumber(n) {
    const str = n.toString()
    return str[1] ? str : `0${str}`
  },
  formatTime(date, dateJoin, timeJoin, flag) {
    if (!date) date = new Date()
    dateJoin = dateJoin || '-'
    timeJoin = timeJoin || ':'
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()

    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

    const t1 = [year, month, day].map(this.formatNumber).join(dateJoin)
    const t2 = [hour, minute, second].map(this.formatNumber).join(timeJoin)
    if (flag === 'date') {
      return `${t1}`
    } else if (flag === 'time') {
      return `${t2}`
    } else if (flag === 'upMinute') {
      const upMinute = [hour, minute].map(this.formatNumber).join(timeJoin)
      return `${t1} ${upMinute}`
    } else {
      return `${t1} ${t2}`
    }
  },
  currentTime(date) {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const t1 = [year, month, day].map(this.formatNumber).join('')
    return `${t1}`
  },
  // 获取浏览器显示比例，缩放比例
  ChangeRatio() {
    let ratio = 0
    const screen = window.screen
    const ua = navigator.userAgent.toLowerCase()
    if (window.devicePixelRatio !== undefined) {
      ratio = window.devicePixelRatio
    } else if (~ua.indexOf('msie')) {
      if (screen.deviceXDPI && screen.logicalXDPI) {
        ratio = screen.deviceXDPI / screen.logicalXDPI
      }
    } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
      ratio = window.outerWidth / window.innerWidth
    }
    if (ratio) {
      ratio = Math.round(ratio * 100)
    }
    console.log('ratio:' + ratio)
    return ratio
  },
  // 时间转化
  getInitTime(limitStartDay, limitEndDay) {
    const now = new Date()
    const currentDate = now.getTime()
    const startTime = new Date(currentDate - limitStartDay * 24 * 3600 * 1000)
    const endTime = new Date(currentDate - limitEndDay * 24 * 3600 * 1000)
    return {
      startTime: this.formatTime(startTime, '-', '', 'date'),
      endTime: this.formatTime(endTime, '-', '', 'date')
    }
  }
}
